import { render } from "./GiveNowButton.vue?vue&type=template&id=e7be8e40"
import script from "./GiveNowButton.vue?vue&type=script&lang=js"
export * from "./GiveNowButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__